
import React from 'react';
import { NativeSelect } from "@material-ui/core";
import { useState } from 'react';
import { InvoiceType } from 'common/constants';


const styles = {    
    invoiceType: {
        border: 'none',
        padding: '0.25rem'
    }
}


export default function InvoiceTypeSelector(props) {
    const { invoiceTypes, onChange } = props;
    const [selectedType, setSelectedType] = useState(invoiceTypes[0])  

    const invoiceTypeChanged = (e) => {        
        setSelectedType(e.target.value)
        onChange(e.target.value)
    }

    const optionForType =(invoiceType) =>{
        const plainString = InvoiceType.plainString(invoiceType);
        const plainStringLower = plainString.toLowerCase()
        return (
            <option id={`${plainStringLower}-option`} 
                    value={invoiceType}
                    key={invoiceType}>{plainString} Invoices</option>
        )
    }

    return (<NativeSelect native="true"
                style={styles.invoiceType}
                disableUnderline={true}
                inputProps={{
                    name: 'invoiceType',
                    id: 'invoiceType'
                }}
    
                value={selectedType}
                onChange={invoiceTypeChanged} 
                >
                {optionForType(invoiceTypes[0])}
                {optionForType(invoiceTypes[1])}                
            </NativeSelect>)
}